module.exports = {
          srcSet: __webpack_public_path__ + "9a448188.jpg"+" 700w"+","+__webpack_public_path__ + "04ec4929.jpg"+" 1400w"+","+__webpack_public_path__ + "0130cbaa.jpg"+" 2100w"+","+__webpack_public_path__ + "01f6d174.jpg"+" 2573w",
          images:[ {path: __webpack_public_path__ + "9a448188.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "04ec4929.jpg",width: 1400,height: 934},{path: __webpack_public_path__ + "0130cbaa.jpg",width: 2100,height: 1401},{path: __webpack_public_path__ + "01f6d174.jpg",width: 2573,height: 1716}],
          src: __webpack_public_path__ + "9a448188.jpg",
          toString:function(){return __webpack_public_path__ + "9a448188.jpg"},
          
          width: 700,
          height: 467
        }